export interface IdentityDocument {
  id: number;
  name: string;
  image: string;
}
